import React, { useState, useEffect } from "react";

import websocketService from "../services/websocket";
import timeIconUrl from "../assets/svg/time.svg";
import stopIconUrl from "../assets/svg/stop.svg";

import "./OrderTimer.css";

interface OrderTimerProps {
  closeTimestamp: number; // timestamp в миллисекундах
  className?: string;
}

const OrderTimer: React.FC<OrderTimerProps> = ({
  closeTimestamp,
  className = "",
}) => {
  const [hoursLeft, setHoursLeft] = useState<string>("");
  const [minutesLeft, setMinutesLeft] = useState<string>("");
  const [secondsLeft, setSecondsLeft] = useState<string>("");
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    const updateTimer = () => {
      // Серверное время, а не Date.now(): экспирация ордера привязана
      // к часам сервера, и отсчёт должен идти от той же базы — иначе
      // перевод системных часов пользователя ломает таймер (см. память).
      const now = websocketService.getCurrentServerTime();
      const difference = closeTimestamp - now;

      if (difference <= 0) {
        // setTimeLeft('00:00:00');
        setIsExpired(true);
        return;
      }

      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setHoursLeft(hours.toString().padStart(2, "0"));
      setMinutesLeft(minutes.toString().padStart(2, "0"));
      setSecondsLeft(seconds.toString().padStart(2, "0"));

      setIsExpired(false);
    };

    // Обновляем таймер сразу
    updateTimer();

    // Обновляем каждую секунду
    const interval = setInterval(updateTimer, 1000);

    // Очищаем интервал при размонтировании компонента
    return () => clearInterval(interval);
  }, [closeTimestamp]);

  return (
    <div
      className={`button order-timer ${isExpired ? "expired" : ""} ${className}`}
    >
      {isExpired ? (
        <>
          <img className="order-timer__img" src={stopIconUrl} alt="Stop logo" />
          <span className="order-timer__text">Expired</span>
        </>
      ) : (
        <>
          <img className="order-timer__img" src={timeIconUrl} alt="Time logo" />
          <div className="order-timer__text">
            <span className="hours">{hoursLeft}</span>
            <span className="separator"> : </span>
            <span className="minutes">{minutesLeft}</span>
            <span className="separator"> : </span>
            <span className="seconds">{secondsLeft}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderTimer;
